<template>
    <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">Devices</h4>
        <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <base-input>
                    <el-input
                            type="search"
                            class="mb-3 search-input"
                            clearable
                            prefix-icon="fal fa-search"
                            placeholder="Search records"
                            v-model="searchQuery"
                            aria-controls="datatables"
                    >
                    </el-input>
                </base-input>
            </div>
            <v-data-table id="SIPDevicesTable"
                          :headers="headers" :search="searchQuery"
                          :items="sipdevices" :loading="isLoadingSIPDevices"
                          item-key="datetime" :pagination.sync="paginationSync"
                          :rows-per-page-items="rowsperpageitems" :custom-filter="tableFilter"
                          show-summary data-app
            >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @dblclick="$emit('show-settings',props.item.name)">
                        <td title="Status">
                            <span v-if="props.item.online" class="text-success"><font-awesome-icon :icon="['fal','wifi']"></font-awesome-icon></span>
                            <span v-if="props.item.online === false" class="text-danger"><font-awesome-icon :icon="['fal','wifi-slash']"></font-awesome-icon></span>
                        </td>
                        <td :title="props.item.name">{{ props.item.extensionName ? props.item.extensionName :
                            props.item.name }}
                        </td>
                        <td>{{ props.item.callerid }}</td>
                        <td>
                            <el-tooltip
                                    :content="'Call recording is enabled on ' + (props.item.extensionName ? props.item.extensionName :
                            props.item.name) + ' to ' + props.item.recordingemail"
                                    effect="dark"
                                    :open-delay="300"
                                    placement="top">
                                <badge v-if="props.item.recordingemail" type="info">Call recording</badge>
                            </el-tooltip>
                        </td>
                        <td>
                            <el-tooltip
                                    content="Open a popup window, where you can edit various settings."
                                    effect="dark"
                                    :open-delay="300"
                                    placement="top">
                                <base-button
                                        @click.native="$emit('show-settings',props.item.name)"
                                        class="edit btn-link"
                                        type="warning"
                                        size="sm"
                                        icon
                                >
                                    <font-awesome-icon :icon="['fal','pencil']"></font-awesome-icon>
                                </base-button>
                            </el-tooltip>
                            <el-tooltip
                                    content="Open a popup window where you can setup Emergency Calling"
                                    effect="dark"
                                    :open-delay="300"
                                    placement="top">
                                <base-button
                                        @click.native="$emit('show-emergency',props.item.name)"
                                        class="edit btn-link"
                                        type="danger"
                                        size="sm"
                                >
                                    <font-awesome-icon :icon="['fal','ambulance']"></font-awesome-icon>
                                </base-button>
                            </el-tooltip>
<!--                            <el-tooltip-->
<!--                                    content="This will try to call the phone remotely"-->
<!--                                    effect="dark"-->
<!--                                    :open-delay="300"-->
<!--                                    placement="top">-->
<!--                                <base-button-->
<!--                                        @click.native="$emit('test',props.item.name)"-->
<!--                                        class="edit btn-link"-->
<!--                                        type="info"-->
<!--                                        size="sm"-->
<!--                                        icon-->
<!--                                >-->
<!--                                    <font-awesome-icon :icon="['fal','phone-volume']"></font-awesome-icon>-->
<!--                                </base-button>-->
<!--                            </el-tooltip>-->
<!--                            <el-tooltip-->
<!--                                    content="This will try to reboot the phone remotely"-->
<!--                                    effect="dark"-->
<!--                                    :open-delay="300"-->
<!--                                    placement="top">-->
<!--                                <base-button-->
<!--                                        @click.native="$emit('reboot',props.item.name)"-->
<!--                                        class="edit btn-link"-->
<!--                                        type="info"-->
<!--                                        size="sm"-->
<!--                                        icon-->
<!--                                >-->
<!--                                    <font-awesome-icon :icon="['fal','power-off']"></font-awesome-icon>-->
<!--                                </base-button>-->
<!--                            </el-tooltip>-->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </card>
</template>

<script>
    import Badge from "../../components/Badge";

    export default {
        name: "SIPDevicesTable",
        components: {Badge},
        computed: {
            sipdevices() {
                return this.$store.getters['sipdevice/sipdevices'];
            },
            isLoadingSIPDevices() {
                return this.$store.getters['sipdevice/isLoading'];
            },
        },
        data() {
            return {
                rowsperpageitems:
                    [5, 10, 25, 50, 100, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

                paginationSync: {
                    rowsPerPage: 10,
                    descending: true,
                    sortBy: 'datetime',
                },
                propsToSearch: ['name', 'extensionName', 'callerid'],
                loading: [],
                headers: [
                    {text: 'Status', value: 'online'},
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'extensionName'
                    },
                    {text: 'CallerID', value: 'callerid'},
                    {text: 'Features', value: ''},
                    {text: 'Actions', value: ''},
                ],
                searchQuery: '',
            };
        },
        methods: {
            tableFilter(items, search, filter) {
                search = search.toString().toLowerCase();
                return items.filter(i => (
                    Object.keys(i).some(j => {
                        return filter(i[j], search)
                    })
                ))
            }
        },
        mounted() {
            if (this.$store.getters['sipdevice/needUpdate']) {
                this.$store.dispatch('sipdevice/loadSIPDevices');
            }

            if (this.$store.getters['did/needUpdate']) {
                this.$store.dispatch('did/loadUniqueDIDs');
            }

        }
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
